import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, priceId: String, email: String, src: String, promo: String }
  static targets = ["spinner", "error"]

  connect() {
    this.redirect()
  }

  retry() {
    this.errorTarget.classList.add("hidden")
    this.spinnerTarget.classList.remove("hidden")
    this.redirect()
  }

  async redirect() {
    try {
      const body = new URLSearchParams({
        price_id: this.priceIdValue,
        email: this.emailValue,
        src: this.srcValue,
        promo: this.promoValue
      })
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: { "Accept": "application/json", "Content-Type": "application/x-www-form-urlencoded" },
        body
      })
      if (!response.ok) throw new Error("checkout failed")
      const data = await response.json()
      window.location = data.url
    } catch (_error) {
      this.spinnerTarget.classList.add("hidden")
      this.errorTarget.classList.remove("hidden")
    }
  }
}
